import React from 'react';
import video from './images/WATRWELL_INTRO.mp4';

function VideoSection() {
  return (
    <section className="vdo">
      <video
        style={{ width: '100%', height: 'auto', objectFit: 'cover' }}
        autoPlay
        loop
        muted
        playsInline
      >
        <source src={video} type="video/mp4" />
      </video>
    </section>
  );
}

export default VideoSection;